export default "__VITE_ASSET__DtCmn_Ov__"